import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import LeadershipContent from "../ones/LeadershipContent";
import PageWithSidebar from "../components/PageWithSidebar";
import PageHero from "../ones/PageHero";
import bgImage from "../assets/image31.jpeg";

export default function View(props) {
  const appContext = useContext(AppContext);

  const heroData = {
    bgImage: bgImage,
    kicker: "Uongozi na Utawala",
    title: "Viongozi & Watendaji Wetu",
    description:
      "Kutana na timu thabiti inayohakikisha uwazi, utawala bora, na usimamizi madhubuti wa rasilimali za wanachama wetu.",
  };

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <PageHero
          bgImage={heroData.bgImage}
          kicker={heroData.kicker}
          heading={heroData.title}
          paragraph={heroData.description}
        />
        <PageWithSidebar>
          <LeadershipContent />
        </PageWithSidebar>
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
